import { render, staticRenderFns } from "./ProviderPurchaseInvoice.vue?vue&type=template&id=504efe64&lang=pug&"
import script from "./ProviderPurchaseInvoice.vue?vue&type=script&lang=js&"
export * from "./ProviderPurchaseInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProviderPurchaseInvoice.vue"
export default component.exports